export default __webpack_public_path__ + "static/DA-Homepage-f59e251362349eca1916cb7cecec5e6d.png";